var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-base-layout"},[_c('Row',{attrs:{"type":"flex"}},[_c('Col',{attrs:{"xs":_vm.xs,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }